export default [
    {
        name: 'cadastro-nota-versao',
        path: 'nota-versao',
        redirect: 'nota-versao/index',
        component: () => import(/* webpackChunkName: 'cadastro-nota-versao' */ '@/views/cadastro/nota-versao/Index'),
        children: [
            {
                meta: {title: 'Lista de notas de versão'},
                name: 'cadastro-nota-versao-index',
                path: 'index',
                component: () => import(/* webpackChunkName: 'cadastro-nota-versao' */ '@/views/cadastro/nota-versao/List.vue'),
            },
            {
                meta: {title: 'Cadastro de nota de versão'},
                name: 'cadastro-nota-versao-create',
                path: 'create',
                component: () => import(/* webpackChunkName: 'cadastro-nota-versao' */ '@/views/cadastro/nota-versao/Form.vue'),
            },
            {
                meta: {title: 'Edição de nota de versão'},
                name: 'cadastro-nota-versao-edit',
                path: 'edit/:id',
                props: route => ({id: parseInt(route.params.id)}),
                component: () => import(/* webpackChunkName: 'cadastro-nota-versao' */ '@/views/cadastro/nota-versao/Form.vue'),
            },
        ],
    },
]